import apiClient from '../apiClient';

export const uploadMessageAttachment = async (file) => {
  if (!file) {
    return null;
  }

  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post(
    '/messaging/messages/attachments',
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    },
  );

  return response?.data ?? null;
};

export const fetchConversations = async () => {
  const response = await apiClient.get('/messaging/conversations');
  const data = Array.isArray(response?.data) ? response.data : [];
  return data;
};

export const fetchConversationMessages = async (conversationId) => {
  if (!conversationId) {
    return [];
  }
  const response = await apiClient.get(`/messaging/conversations/${conversationId}/messages`);
  const data = Array.isArray(response?.data) ? response.data : [];
  return data;
};

export const createConversation = async (payload) => {
  const response = await apiClient.post('/messaging/conversations', payload);
  return response?.data;
};

export const sendMessage = async (payload) => {
  const response = await apiClient.post('/messaging/messages', payload);
  return response?.data;
};

export const markConversationSeen = async (conversationId) => {
  if (!conversationId) {
    return { messageIds: [], seenAt: new Date().toISOString() };
  }

  const response = await apiClient.post(
    `/messaging/conversations/${conversationId}/mark-seen`,
  );

  return response?.data;
};

export const deleteConversation = async (conversationId) => {
  if (!conversationId) {
    return null;
  }

  const response = await apiClient.delete(
    `/messaging/conversations/${conversationId}`,
  );

  return response?.data ?? null;
};

export const fetchConversationUnseenCount = async (conversationId) => {
  if (!conversationId) {
    return 0;
  }

  const response = await apiClient.get(
    `/messaging/conversations/${conversationId}/unseen-count`,
  );

  const value = response?.data;
  if (typeof value === 'number') {
    return value;
  }

  if (value && typeof value === 'object' && typeof value.count === 'number') {
    return value.count;
  }

  return 0;
};

export default {
  fetchConversations,
  fetchConversationMessages,
  createConversation,
  sendMessage,
  markConversationSeen,
  fetchConversationUnseenCount,
  uploadMessageAttachment,
  deleteConversation,
};
